<template>
    <h3
        :class="
            twMerge(
                'whitespace-pre-line text-left text-[1.5rem] font-bold leading-[1.3] lg:text-[2rem]',
                locale === 'en' &&
                    'leading-[1.1] tracking-[-0.03em] lg:tracking-[-0.01em]',
                locale === 'ja' && '',
                locale === 'ko' && '',
                $attrs.class,
            )
        "
    >
        <slot />
    </h3>
</template>

<script setup>
import { twMerge } from "tailwind-merge";
const { locale } = useI18n();
</script>
